export const hashBoolean = (value: boolean): number => Math.imul(452614237 + +value, 866975723)
